import React from "react";
import PropTypes from "prop-types";
import {
  Typography,
  MenuItem,
  ListSubheader,
} from "@material-ui/core";
import ApartmentIcon from "@material-ui/icons/Apartment";
import EmojiTransportationIcon from "@material-ui/icons/EmojiTransportation";
import { faWarehouseFull as FGIcon } from "@fortawesome/pro-duotone-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from "clsx";
import { ENTITY_TYPE } from "../../constants";
import _ from "lodash";

const FacilityDropdownMenu = React.memo(({ hierarchicalFacilities, loadingFacilities, classes, onFacilitySelect }) => {
  if (loadingFacilities) {
    return (
      <MenuItem value="" disabled>
        Loading...
      </MenuItem>
    );
  }

  if (!hierarchicalFacilities || hierarchicalFacilities.length === 0) {
    return (
      <MenuItem value="" disabled>
        No facilities available
      </MenuItem>
    );
  }

  const menuItems = [];

  hierarchicalFacilities.forEach((parent) => {
    menuItems.push(
      <ListSubheader
        key={`parent-${parent.id}`}
        onClickCapture={(e) => e.stopPropagation()}
        className={clsx(
          classes.transparentSubheader,
          classes.nonStickySubheader
        )}
      >
        <Typography
          color="primary"
          className={classes.facilityParentSpacing}
          variant="h6"
        >
          <ApartmentIcon
            className={classes.facilityParentIconSpacing}
            fontSize="small"
          />
          {parent.name}
        </Typography>
      </ListSubheader>
    );

    if (parent.children && parent.children.length > 0) {
      const sortedChildren = _.orderBy(parent.children, ["name"], ["asc"]);
      sortedChildren.forEach((child) => {
        if (child.entityType === ENTITY_TYPE.FacilityGroup) {
          menuItems.push(
            <ListSubheader
              key={`group-${child.id}`}
              className={clsx(
                classes.facilityGroupSpacing,
                classes.transparentSubheaderGroup,
                classes.nonStickySubheader
              )}
              onClickCapture={(e) => e.stopPropagation()}
            >
              <Typography
                className={classes.facilityGroupLabel}
                color="primary"
              >
                <div className={classes.facilityGroupIconContainer}>
                  <FontAwesomeIcon icon={FGIcon} fontSize="small" />
                </div>
                {child.name}
              </Typography>
            </ListSubheader>
          );

          if (child.children && child.children.length > 0) {
            const sortedGrandChildren = _.orderBy(
              child.children,
              ["name"],
              ["asc"]
            );
            sortedGrandChildren.forEach((grandChild) => {
              menuItems.push(
                <MenuItem
                  key={grandChild.id}
                  value={grandChild.id}
                  className={classes.nestedFacility}
                  onClick={() => { onFacilitySelect(grandChild.id); }}
                >
                  <EmojiTransportationIcon fontSize="small" />
                  <span className={classes.facilityNameSpacing}>
                    {grandChild.name}
                  </span>
                </MenuItem>
              );
            });
          }
        } else {
          menuItems.push(
            <MenuItem
              key={child.id}
              value={child.id}
              className={classes.standAloneFacility}
              onClick={() => { onFacilitySelect(child.id); }}
            >
              <EmojiTransportationIcon fontSize="small" />
              <span className={classes.facilityNameSpacing}>
                {child.name}
              </span>
            </MenuItem>
          );
        }
      });
    }
  });

  return menuItems;
});

FacilityDropdownMenu.displayName = "FacilityDropdownMenu";

FacilityDropdownMenu.propTypes = {
  hierarchicalFacilities: PropTypes.array.isRequired,
  loadingFacilities: PropTypes.bool.isRequired,
  classes: PropTypes.object.isRequired,
  onFacilitySelect: PropTypes.func,
};

export default FacilityDropdownMenu;
